import React from 'react'
import { Field } from 'redux-form'

export default () => (
  <div className="equote-package-additional-details-form--input-comments">
    <label className="equote-package-additional-details-form--input-group--label">
      Additional Comments?
    </label>
    <Field
      name="Additional Comments"
      component="textarea"
      className="equote-package-additional-details-form--textarea"
      placeholder="Use this place to tell us anything else we should know."
    />
  </div>
)
